import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { ProductRoute } from "../types/router";
import { designControlsApi } from "../api/designControls";

export const useSelectedProduct = () => {
  const { companyId } = useCurrentUser();
  const { product } = useParams<ProductRoute>() as ProductRoute;

  const productQuery = useQuery({
    queryKey: ["PRODUCT", companyId, product],
    queryFn: () => designControlsApi.retrieveProductById(companyId, product),
    retry: false,
  });

  const configQuery = useQuery({
    queryKey: ["PRODUCT_CONFIGS", companyId, product],
    queryFn: () => designControlsApi.retrieveAllPolicies(companyId, product),
    enabled: !!productQuery.data,
  });

  return {
    isLoading:
      productQuery.isLoading ||
      productQuery.isFetching ||
      configQuery.isLoading ||
      configQuery.isFetching,
    product: productQuery.data,
    configs: configQuery.data,
  };
};
